// extracted by mini-css-extract-plugin
module.exports = {"TransferMoneyDialog":"transfer-money-dialog_TransferMoneyDialog__U5thK","Form":"transfer-money-dialog_Form__3GtuF"};